/** Mirrors backend `ScheduledCallAttemptOutcome`. */
export enum ScheduledCallAttemptOutcome {
  Answered = 1,
  NoAnswer = 2,
  Busy = 3,
  Rejected = 4,
  OriginateFailed = 5,
  Unknown = 6,
  Declined = 7,
  Timeout = 8,
  AgentUnavailable = 9,
  Cancelled = 10,
}
